(() => {
  const I18N = window.CELESTIAR_I18N || {};
  const LOCALE = I18N.locale === 'en' ? 'en-GB' : 'fr-FR';
  const defaults = {
    prenom: 'LÉA',
    date: '12 mars 2024',
    heure: '08h42',
    ville: 'Paris',
    phrase: 'Le jour où tout a commencé',
  };

  const money = (cents) => new Intl.NumberFormat(LOCALE, {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
  }).format((Number(cents) || 0) / 100);

  const normalizeFrame = (value) => {
    const clean = String(value || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    if (clean.includes('chene')) return 'chene';
    if (clean.includes('blanc')) return 'blanc';
    return 'noir';
  };

  const formatDate = (value) => {
    if (!value) return defaults.date;
    const date = new Date(`${value}T12:00:00`);
    if (Number.isNaN(date.getTime())) return value;
    return date.toLocaleDateString(LOCALE, { day: 'numeric', month: 'long', year: 'numeric' });
  };

  const fitText = (element, base, minimum, maxChars) => {
    if (!element) return;
    const length = Math.max(1, element.textContent.trim().length);
    const scale = Math.min(1, maxChars / length);
    element.style.fontSize = `${Math.max(minimum, base * scale)}cqw`;
  };

  function initProductPage() {
    const root = document.querySelector('[data-product-page]');
    if (!root) return;
    /* Mémorise le produit consulté pour que « Créez votre ciel » ajoute ce même produit au panier */
    const handleMatch = window.location.pathname.match(/\/products\/([^/?#]+)/);
    if (handleMatch) { try { window.sessionStorage.setItem('celestiar_produit', decodeURIComponent(handleMatch[1])); } catch (e) {} }

    const form = document.getElementById('ProductForm');
    const variantNode = root.querySelector('[data-variants-json]');
    const selectedNode = root.querySelector('[data-selected-variant-json]');
    const hiddenVariant = form ? form.querySelector('[data-variant-id]') : null;
    const addButton = form ? form.querySelector('[data-add-to-cart]') : null;
    const addLabel = form ? form.querySelector('[data-add-label]') : null;
    const error = form ? form.querySelector('[data-form-error]') : null;
    const frameWrap = root.querySelector('.poster-frame');
    if (!form || !variantNode || !selectedNode || !hiddenVariant || !addButton) return;

    let variants = [];
    let selectedVariant = null;
    try {
      variants = JSON.parse(variantNode.textContent || '[]');
      selectedVariant = JSON.parse(selectedNode.textContent || 'null');
    } catch (event) {
      variants = [];
    }
    const options = selectedVariant && Array.isArray(selectedVariant.options) ? [...selectedVariant.options] : [];

    const findVariant = () => variants.find((variant) => (
      Array.isArray(variant.options) && variant.options.every((option, index) => option === options[index])
    ));

    const updateVariant = () => {
      const variant = findVariant();
      if (!variant) {
        hiddenVariant.value = '';
        addButton.disabled = true;
        if (addLabel) addLabel.textContent = (I18N.not_found || 'Combinaison introuvable');
        return;
      }
      hiddenVariant.value = variant.id;
      if (variant.available === false) {
        addButton.disabled = true;
        if (addLabel) addLabel.textContent = I18N.unavailable || (I18N.locale === 'en' ? 'Unavailable in this combination' : 'Indisponible dans cette combinaison');
        return;
      }
      addButton.disabled = !!form.celestiarInvalid;
      if (addLabel) addLabel.textContent = (I18N.add_to_cart_tpl || 'Ajouter au panier — __PRICE__').replace('__PRICE__', money(variant.price));
      const frameGroup = [...root.querySelectorAll('[data-option-position]')].find((group) => /cadre|frame/.test(group.dataset.optionName || ''));
      const frameValue = frameGroup ? options[Number(frameGroup.dataset.optionPosition) - 1] : undefined;
      if (frameWrap && frameValue) frameWrap.dataset.frame = normalizeFrame(frameValue);
      if (window.history && window.history.replaceState && variant.id) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
    };

    root.querySelectorAll('[data-option-position]').forEach((group) => {
      const position = Number(group.dataset.optionPosition || 1) - 1;
      group.querySelectorAll('[data-option-value]').forEach((button) => {
        button.addEventListener('click', () => {
          options[position] = button.dataset.optionValue;
          group.querySelectorAll('[data-option-value]').forEach((item) => item.classList.toggle('active', item === button));
          updateVariant();
        });
      });
    });

    /* Pré-sélection du cadre via l'URL (?cadre=chene|blanc|noir) — vitrine cadres */
    const cadreParam = new URLSearchParams(window.location.search).get('cadre');
    if (cadreParam) {
      const strip = (s) => (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
      const wanted = strip(cadreParam);
      root.querySelectorAll('[data-option-value]').forEach((button) => {
        const val = strip(button.dataset.optionValue);
        if (val === wanted || val.startsWith(wanted)) button.click();
      });
    }

    const fields = {
      prenom: root.querySelector('[data-live-field="prenom"]'),
      date: root.querySelector('[data-live-field="date"]'),
      ville: root.querySelector('[data-live-field="ville"]'),
      phrase: root.querySelector('[data-live-field="phrase"]'),
    };
    const values = { ...defaults };
    const counter = form.querySelector('[data-message-counter]');

    const renderPreview = () => {
      fields.prenom.textContent = values.prenom || defaults.prenom;
      fields.date.textContent = `${values.date || defaults.date} · ${values.heure || defaults.heure}`;
      fields.ville.textContent = values.ville || defaults.ville;
      fields.phrase.textContent = values.phrase || defaults.phrase;
      fitText(fields.prenom, 9, 4.7, 10);
      fitText(fields.date, 3.6, 2.2, 24);
      fitText(fields.ville, 3.4, 2.1, 18);
      fitText(fields.phrase, 3.4, 2.1, 44);
    };

    form.querySelectorAll('[data-preview-input]').forEach((input) => {
      input.addEventListener('input', () => {
        const key = input.dataset.previewInput;
        let value = input.value.trim();
        if (key === 'prenom') value = value.toUpperCase();
        if (key === 'ville' && value) value = value.charAt(0).toUpperCase() + value.slice(1);
        if (key === 'phrase' && value) value = value.charAt(0).toUpperCase() + value.slice(1);
        if (key === 'date') value = formatDate(input.value);
        if (key === 'heure') value = input.value ? input.value.replace(':', 'h') : '';
        values[key] = value;
        if (key === 'phrase' && counter) counter.textContent = `${input.value.length}/60`;
        renderPreview();
        updateSkyLink();
      });
    });

    /* Lien « Voir le vrai ciel de cette date » vers /pages/ciel pré-rempli */
    const skyLink = root.querySelector('[data-sky-link]');
    const updateSkyLink = () => {
      if (!skyLink) return;
      const raw = (k) => { const el = form.querySelector(`[data-preview-input="${k}"]`); return el ? el.value : ''; };
      const p = new URLSearchParams();
      if (raw('date')) p.set('date', raw('date'));
      if (raw('heure')) p.set('heure', raw('heure'));
      if (raw('ville')) p.set('lieu', raw('ville'));
      const qs = p.toString();
      const base = skyLink.getAttribute('href').split('?')[0];
      skyLink.setAttribute('href', qs ? `${base}?${qs}` : base);
    };
    updateSkyLink();

    form.addEventListener('submit', (event) => {
      if (error) error.hidden = true;
      if (!hiddenVariant.value || addButton.disabled) {
        event.preventDefault();
        if (error) {
          error.textContent = I18N.combo_error || 'Cette combinaison de taille et de cadre est indisponible.';
          error.hidden = false;
        }
        return;
      }
      if (!form.checkValidity()) {
        event.preventDefault();
        form.reportValidity();
        if (error) {
          error.textContent = I18N.form_error || 'Complétez le prénom, la date, l’heure, la ville et la vérification de l’orthographe.';
          error.hidden = false;
        }
        return;
      }
      addButton.disabled = true;
      if (addLabel) addLabel.textContent = I18N.adding || 'Ajout au panier…';
      if (window.celestiarToast) window.celestiarToast(I18N.added_to_cart || 'Votre affiche rejoint le panier.');
    });

    renderPreview();
    updateVariant();
  }

  document.addEventListener('DOMContentLoaded', initProductPage);
})();
